import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=4b65e6dc&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=4b65e6dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65e6dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b65e6dc')) {
      api.createRecord('4b65e6dc', component.options)
    } else {
      api.reload('4b65e6dc', component.options)
    }
    module.hot.accept("./uploader.vue?vue&type=template&id=4b65e6dc&scoped=true&", function () {
      api.rerender('4b65e6dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/uploader.vue"
export default component.exports